import React from 'react';
import classnames from "classnames";
import "./ViewBanner.scss";

const ViewBanner = ({title,isLocations}) => {
	return (
		<div className={classnames(
			"row view__banner",{
				"view__banner__locations": isLocations
			}
		)}>
			<div className="col col-xs-12">
				<div className="row boxed">
					<div className="col col-xs-12">
						<div className="view__banner__title">
							<h2>{title}</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ViewBanner;